module.exports = __webpack_public_path__ + "img/illustration-mailbox-empty-state.6ccee4ea.png";